// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Black and Yellow Theme */
:root {
  --black: #111111;
  --black-light: #1a1a1a;
  --black-lighter: #222222;
  --yellow: #f5d300;
  --yellow-dark: #e5c300;
  --yellow-light: #fff44f;
  --gray-dark: #333333;
  --gray: #777777;
  --white: #ffffff;
}

/* Override Material UI colors */
body {
  background-color: var(--black) !important;
  color: var(--yellow) !important;
}

/* App Bar */
.MuiAppBar-root {
  background-color: var(--black-light) !important;
  color: var(--yellow) !important;
  border-bottom: 2px solid var(--yellow) !important;
}

/* Paper */
.MuiPaper-root {
  background-color: var(--black-light) !important;
  color: var(--yellow) !important;
  border: 1px solid var(--gray-dark) !important;
}

/* Buttons */
.MuiButton-contained {
  background-color: var(--yellow) !important;
  color: var(--black) !important;
}

.MuiButton-contained:hover {
  background-color: var(--yellow-dark) !important;
}

.MuiButton-outlined {
  color: var(--yellow) !important;
  border-color: var(--yellow) !important;
}

.MuiButton-outlined:hover {
  background-color: rgba(245, 211, 0, 0.1) !important;
}

.MuiButton-text {
  color: var(--yellow) !important;
}

/* Form Elements */
.MuiInputBase-root {
  color: var(--white) !important;
  background-color: var(--black-lighter) !important;
  border-radius: 4px !important;
}

.MuiInputLabel-root {
  color: var(--yellow) !important;
}

.MuiFormLabel-root {
  color: var(--gray) !important;
}

.MuiFormLabel-root.Mui-focused {
  color: var(--yellow) !important;
}

.MuiOutlinedInput-notchedOutline {
  border-color: var(--gray-dark) !important;
}

.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: var(--yellow-dark) !important;
}

.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: var(--yellow) !important;
}

/* Typography */
.MuiTypography-root {
  color: var(--white) !important;
}

h1, h2, h3, h4, h5, h6, .MuiTypography-h1, .MuiTypography-h2, 
.MuiTypography-h3, .MuiTypography-h4, .MuiTypography-h5, .MuiTypography-h6 {
  color: var(--yellow) !important;
}

/* Tabs */
.MuiTabs-indicator {
  background-color: var(--yellow) !important;
}

.MuiTab-root {
  color: var(--gray) !important;
}

.MuiTab-root.Mui-selected {
  color: var(--yellow) !important;
}

/* List Items */
.MuiListItem-root {
  border-bottom: 1px solid var(--gray-dark);
}

/* Links */
a, .MuiLink-root {
  color: var(--yellow-light) !important;
}

/* Pagination */
.MuiPaginationItem-root {
  color: var(--white) !important;
}

.MuiPaginationItem-root.Mui-selected {
  background-color: var(--yellow) !important;
  color: var(--black) !important;
}

/* Alerts */
.MuiAlert-standardSuccess {
  background-color: rgba(76, 175, 80, 0.2) !important;
  color: #81c784 !important;
}

.MuiAlert-standardWarning {
  background-color: rgba(255, 152, 0, 0.2) !important;
  color: #ffb74d !important;
}

.MuiAlert-standardError {
  background-color: rgba(211, 47, 47, 0.2) !important;
  color: #e57373 !important;
}

.MuiAlert-standardInfo {
  background-color: rgba(2, 136, 209, 0.2) !important;
  color: #4fc3f7 !important;
}

/* AG Grid styling */
.ag-theme-material {
  --ag-background-color: var(--black-light) !important;
  --ag-foreground-color: var(--white) !important;
  --ag-header-background-color: var(--black-lighter) !important;
  --ag-header-foreground-color: var(--yellow) !important;
  --ag-odd-row-background-color: var(--black) !important;
  --ag-border-color: var(--gray-dark) !important;
  --ag-secondary-border-color: var(--gray-dark) !important;
  --ag-row-hover-color: rgba(245, 211, 0, 0.1) !important;
  --ag-selected-row-background-color: rgba(245, 211, 0, 0.2) !important;
  --ag-font-size: 14px !important;
  --ag-font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
}

.ag-header-cell {
  font-weight: bold !important;
}

/* Snackbar */
.MuiSnackbarContent-root {
  background-color: var(--black-lighter) !important;
  color: var(--white) !important;
  border-left: 4px solid var(--yellow) !important;
}

/* Custom element styles */
.highlight-border {
  border: 2px solid var(--yellow) !important;
}

.highlight-text {
  color: var(--yellow) !important;
  font-weight: bold !important;
}

/* Divider with yellow effect */
.yellow-divider {
  height: 3px;
  background: linear-gradient(90deg, var(--yellow) 0%, var(--yellow-dark) 50%, transparent 100%);
  margin: 20px 0;
}

/* Animated pulsing effect for important elements */
@keyframes pulse-yellow {
  0% {
    box-shadow: 0 0 0 0 rgba(245, 211, 0, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(245, 211, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(245, 211, 0, 0);
  }
}

.pulse-effect {
  animation: pulse-yellow 2s infinite;
}`, "",{"version":3,"sources":["webpack://./src/theme.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,+CAA+C;EAC/C,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA,UAAU;AACV;EACE,+CAA+C;EAC/C,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA,YAAY;AACZ;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,iDAAiD;EACjD,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA,SAAS;AACT;EACE,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,oDAAoD;EACpD,8CAA8C;EAC9C,6DAA6D;EAC7D,sDAAsD;EACtD,sDAAsD;EACtD,8CAA8C;EAC9C,wDAAwD;EACxD,uDAAuD;EACvD,qEAAqE;EACrE,+BAA+B;EAC/B,uEAAuE;AACzE;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,aAAa;AACb;EACE,iDAAiD;EACjD,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA,0BAA0B;AAC1B;EACE,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,8FAA8F;EAC9F,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["/* Black and Yellow Theme */\n:root {\n  --black: #111111;\n  --black-light: #1a1a1a;\n  --black-lighter: #222222;\n  --yellow: #f5d300;\n  --yellow-dark: #e5c300;\n  --yellow-light: #fff44f;\n  --gray-dark: #333333;\n  --gray: #777777;\n  --white: #ffffff;\n}\n\n/* Override Material UI colors */\nbody {\n  background-color: var(--black) !important;\n  color: var(--yellow) !important;\n}\n\n/* App Bar */\n.MuiAppBar-root {\n  background-color: var(--black-light) !important;\n  color: var(--yellow) !important;\n  border-bottom: 2px solid var(--yellow) !important;\n}\n\n/* Paper */\n.MuiPaper-root {\n  background-color: var(--black-light) !important;\n  color: var(--yellow) !important;\n  border: 1px solid var(--gray-dark) !important;\n}\n\n/* Buttons */\n.MuiButton-contained {\n  background-color: var(--yellow) !important;\n  color: var(--black) !important;\n}\n\n.MuiButton-contained:hover {\n  background-color: var(--yellow-dark) !important;\n}\n\n.MuiButton-outlined {\n  color: var(--yellow) !important;\n  border-color: var(--yellow) !important;\n}\n\n.MuiButton-outlined:hover {\n  background-color: rgba(245, 211, 0, 0.1) !important;\n}\n\n.MuiButton-text {\n  color: var(--yellow) !important;\n}\n\n/* Form Elements */\n.MuiInputBase-root {\n  color: var(--white) !important;\n  background-color: var(--black-lighter) !important;\n  border-radius: 4px !important;\n}\n\n.MuiInputLabel-root {\n  color: var(--yellow) !important;\n}\n\n.MuiFormLabel-root {\n  color: var(--gray) !important;\n}\n\n.MuiFormLabel-root.Mui-focused {\n  color: var(--yellow) !important;\n}\n\n.MuiOutlinedInput-notchedOutline {\n  border-color: var(--gray-dark) !important;\n}\n\n.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: var(--yellow-dark) !important;\n}\n\n.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: var(--yellow) !important;\n}\n\n/* Typography */\n.MuiTypography-root {\n  color: var(--white) !important;\n}\n\nh1, h2, h3, h4, h5, h6, .MuiTypography-h1, .MuiTypography-h2, \n.MuiTypography-h3, .MuiTypography-h4, .MuiTypography-h5, .MuiTypography-h6 {\n  color: var(--yellow) !important;\n}\n\n/* Tabs */\n.MuiTabs-indicator {\n  background-color: var(--yellow) !important;\n}\n\n.MuiTab-root {\n  color: var(--gray) !important;\n}\n\n.MuiTab-root.Mui-selected {\n  color: var(--yellow) !important;\n}\n\n/* List Items */\n.MuiListItem-root {\n  border-bottom: 1px solid var(--gray-dark);\n}\n\n/* Links */\na, .MuiLink-root {\n  color: var(--yellow-light) !important;\n}\n\n/* Pagination */\n.MuiPaginationItem-root {\n  color: var(--white) !important;\n}\n\n.MuiPaginationItem-root.Mui-selected {\n  background-color: var(--yellow) !important;\n  color: var(--black) !important;\n}\n\n/* Alerts */\n.MuiAlert-standardSuccess {\n  background-color: rgba(76, 175, 80, 0.2) !important;\n  color: #81c784 !important;\n}\n\n.MuiAlert-standardWarning {\n  background-color: rgba(255, 152, 0, 0.2) !important;\n  color: #ffb74d !important;\n}\n\n.MuiAlert-standardError {\n  background-color: rgba(211, 47, 47, 0.2) !important;\n  color: #e57373 !important;\n}\n\n.MuiAlert-standardInfo {\n  background-color: rgba(2, 136, 209, 0.2) !important;\n  color: #4fc3f7 !important;\n}\n\n/* AG Grid styling */\n.ag-theme-material {\n  --ag-background-color: var(--black-light) !important;\n  --ag-foreground-color: var(--white) !important;\n  --ag-header-background-color: var(--black-lighter) !important;\n  --ag-header-foreground-color: var(--yellow) !important;\n  --ag-odd-row-background-color: var(--black) !important;\n  --ag-border-color: var(--gray-dark) !important;\n  --ag-secondary-border-color: var(--gray-dark) !important;\n  --ag-row-hover-color: rgba(245, 211, 0, 0.1) !important;\n  --ag-selected-row-background-color: rgba(245, 211, 0, 0.2) !important;\n  --ag-font-size: 14px !important;\n  --ag-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif !important;\n}\n\n.ag-header-cell {\n  font-weight: bold !important;\n}\n\n/* Snackbar */\n.MuiSnackbarContent-root {\n  background-color: var(--black-lighter) !important;\n  color: var(--white) !important;\n  border-left: 4px solid var(--yellow) !important;\n}\n\n/* Custom element styles */\n.highlight-border {\n  border: 2px solid var(--yellow) !important;\n}\n\n.highlight-text {\n  color: var(--yellow) !important;\n  font-weight: bold !important;\n}\n\n/* Divider with yellow effect */\n.yellow-divider {\n  height: 3px;\n  background: linear-gradient(90deg, var(--yellow) 0%, var(--yellow-dark) 50%, transparent 100%);\n  margin: 20px 0;\n}\n\n/* Animated pulsing effect for important elements */\n@keyframes pulse-yellow {\n  0% {\n    box-shadow: 0 0 0 0 rgba(245, 211, 0, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(245, 211, 0, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(245, 211, 0, 0);\n  }\n}\n\n.pulse-effect {\n  animation: pulse-yellow 2s infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
